module.exports = __webpack_public_path__ + "trunking-bottom-bw.svg?1faad7c6aea579b84c981ec82d79e762";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/trunking-bottom-bw.svg
// module id = 85
// module chunks = 0